import { SchemeType } from '@acorn-portal/shared/src/services/interface/Shared';

/**
 * @fileOverview
 * Utility functions for determining whether a given scheme is classified as a "young driver" scheme.
 *
 * Exports:
 * - isYoungDriver: Checks if a given scheme is one of the supported young driver schemes.
 *
 * Young driver schemes currently include:
 *   - AcornProtectYD
 *   - CarrotYD
 *   - MyPolicyYD
 */
const youngDriversSchemes = ['AcornProtectYD', 'CarrotYD', 'MyPolicyYD'] as const satisfies readonly SchemeType[];
type YoungDriverScheme = (typeof youngDriversSchemes)[number];

/**
 * Determines if a given scheme is a young driver scheme.
 *
 * This utility function checks whether the provided scheme identifier
 * corresponds to one of the supported young driver schemes:
 * - AcornProtectYD
 * - CarrotYD
 * - MyPolicyYD
 *
 * @param scheme - The scheme type to check. Must be one of the valid young driver scheme types.
 * @returns `true` if the scheme is a young driver scheme, `false` otherwise.
 */
function isYoungDriver(scheme?: SchemeType): scheme is YoungDriverScheme {
	if (!scheme) return false;
	return youngDriversSchemes.includes(scheme as YoungDriverScheme);
}
export default isYoungDriver;
